<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-01 16:24:50
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-02 14:28:22
 * @Description: 
-->
<template>
  <section
    id="hero"
    class="h-740px bg-#f4f9ff lt-sm:h-auto lt-sm:aspect-[750/880] lt-sm:bg-#e8f2ff relative overflow-hidden"
    data-section
  >
    <picture aria-hidden="true">
      <source srcset="/assets/img/figma/hero-banner-mobile.png" media="(max-width: 767px)" />
      <img
        class="h-740px lt-sm:inset-0 lt-sm:left-0 lt-sm:h-full lt-sm:w-full lt-sm:translate-x-0 lt-sm:hover:translate-x-0 lt-sm:hover:translate-y-0 absolute left-1/2 w-full max-w-none translate-x-[-50%] object-cover object-top transition-transform duration-450 hover:translate-x-[-50%] hover:translate-y-[-4px]"
        src="/assets/img/figma/hero-banner.jpg"
        alt=""
      />
    </picture>

    <div class="landing-container pt-70px lt-sm:h-full lt-sm:px-32px lt-sm:pt-80px relative z-1">
      <div class="w-637px pt-132px lt-sm:mx-auto lt-sm:w-full lt-sm:pt-0 lt-sm:text-center">
        <h1
          class="pf-sc-semibold max-w-620px font-s-56px tracking-0 text-#0f172a lt-sm:max-w-full lt-sm:font-s-56px lt-sm:leading-[68px] m-0 leading-[1.15]"
        >
          绘管家物业云平台
        </h1>
        <p
          class="pf-sc-regular mt-22px max-w-560px font-s-23px text-#1e293b lt-sm:mx-auto lt-sm:mt-12px lt-sm:max-w-610px lt-sm:px-25px lt-sm:font-s-26px lt-sm:leading-[40px] mb-0 leading-[1.6]"
        >
          打通档案、收费、设备、任务、服务与数据决策，让物业管理更简单、更规范、更高效。
        </p>

        <div class="mt-34px gap-14px lt-sm:hidden flex flex-wrap">
          <a
            class="pf-sc-semibold h-56px rounded-8px bg-#0f67f8 px-24px font-s-18px hover:-translate-y-2px hover:bg-#0756d8 inline-flex items-center justify-center text-white shadow-[0_14px_30px_rgba(15,103,248,0.24)] transition-all duration-200"
            href="#contact"
            @click="emitNavigate($event, 'contact')"
          >
            免费咨询
          </a>
          <a
            class="pf-sc-semibold h-56px rounded-8px border-#d7e3f5 px-24px font-s-18px text-#1e293b hover:-translate-y-2px hover:border-#0f67f8 hover:bg-#eaf3ff inline-flex items-center justify-center border bg-white transition-all duration-200"
            href="#capabilities"
            @click="emitNavigate($event, 'capabilities')"
          >
            查看核心能力
          </a>
        </div>

        <dl
          class="mt-36px gap-48px lt-sm:mx-auto lt-sm:mt-20px lt-sm:justify-center lt-sm:gap-76px flex"
        >
          <div
            v-for="metric in metrics"
            :key="metric.label"
            class="min-w-86px lt-sm:min-w-0! lt-sm:items-center flex flex-col items-start"
          >
            <dt
              class="d-din-pro-600-semibold font-s-34px text-#0f67f8 lt-sm:font-s-52px leading-none"
            >
              {{ metric.value }}
            </dt>
            <dd class="pf-sc-regular mt-8px font-s-14px text-#64748b lt-sm:font-s-24px m-0">
              {{ metric.label }}
            </dd>
          </div>
        </dl>
      </div>
    </div>

    <div
      class="gap-14px lt-sm:absolute lt-sm:bottom-80px lt-sm:left-1/2 lt-sm:mt-0 lt-sm:flex! lt-sm:w-[560px]! lt-sm:max-w-[calc(100%_-_64px)]! lt-sm:translate-x-[-50%] lt-sm:gap-16px! relative z-3 mx-auto hidden w-[min(100%,520px)] justify-center"
    >
      <a
        class="pf-sc-semibold h-48px rounded-8px bg-#0f67f8 px-14px font-s-17px hover:-translate-y-2px hover:bg-#0756d8 lt-sm:h-83px lt-sm:min-w-0 lt-sm:rounded-8px lt-sm:font-s-28px inline-flex flex-1 items-center justify-center whitespace-nowrap text-white shadow-[0_14px_30px_rgba(15,103,248,0.24)] transition-all duration-200"
        href="#contact"
        @click="emitNavigate($event, 'contact')"
      >
        免费咨询
      </a>
      <a
        class="pf-sc-semibold h-48px rounded-8px border-#d7e3f5 px-14px font-s-17px text-#1e293b hover:-translate-y-2px hover:border-#0f67f8 hover:bg-#eaf3ff lt-sm:h-83px lt-sm:min-w-0 lt-sm:rounded-8px lt-sm:font-s-28px inline-flex flex-1 items-center justify-center border bg-white whitespace-nowrap transition-all duration-200"
        href="#capabilities"
        @click="emitNavigate($event, 'capabilities')"
      >
        查看核心能力
      </a>
    </div>
  </section>
</template>

<script setup lang="ts">
  defineOptions({
    name: 'HomeHero',
  })

  defineProps<{
    metrics: Array<{
      label: string
      value: string
    }>
  }>()

  const emit = defineEmits<{
    navigate: [sectionId: string]
  }>()

  const emitNavigate = (event: MouseEvent, sectionId: string) => {
    event.preventDefault()
    emit('navigate', sectionId)
  }
</script>
